import { useState, useEffect } from 'react';
import { featureFlags, FEATURE_FLAGS } from '@/lib/featureFlags';
import Waitlist from '@/pages/Waitlist';
import SignupPage from '@/app/auth/signup/page';

/**
 * Route wrapper that checks the waitlist_mode feature flag.
 * When enabled, shows the waitlist page instead of signup.
 */
export function WaitlistGate() {
  const [isWaitlistMode, setIsWaitlistMode] = useState<boolean | null>(null);

  useEffect(() => {
    const checkWaitlistMode = async () => {
      const enabled = await featureFlags.isEnabled(FEATURE_FLAGS.WAITLIST_MODE);
      setIsWaitlistMode(enabled);
    };
    checkWaitlistMode();
  }, []);

  // Show loading state while checking feature flag
  if (isWaitlistMode === null) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Show waitlist if enabled, otherwise show normal signup
  return isWaitlistMode ? <Waitlist /> : <SignupPage />;
}
